<template>
  <div class="Myinfor">
    <div class="Myinfor_tops">
      <h4 class="Thetitle">基本信息</h4>
      <div
        class="statisid"
        v-show="this.$store.state.user.dentity !== '注册用户'"
      >
        <img src="../../../assets/stateis.png" alt="" />
        <span
          v-if="
            (thisa.users.status == '已申请' &&
              doctorData[0] &&
              doctorData[0].status !== '已通过') ||
            (doctorData[0] &&
              doctorData[0].status === '待审核' &&
              thisa.users.status !== '已通过')
            // thisa.users.status === '已申请' ||
            // (doctorData[0] && doctorData[0].status === '待审核')
          "
          style="color: #999999"
          >审核中</span
        >
        <span
          @click="dialogVisiblesas = true"
          v-if="
            thisa.users.status === '已驳回' ||
            (doctorData[0] && doctorData[0].status === '已驳回')
          "
          style="color: #f11e1e"
          >审核失败(查看原因)</span
        >
        <span
          v-if="
            thisa.users.status === '已通过' ||
            (doctorData[0] && doctorData[0].status === '已通过')
          "
          style="color: #00d31e"
          >恭喜您，成为{{ thisa.users.dentity }}</span
        >
      </div>
    </div>

    <el-dialog
      title="驳回原因"
      :visible.sync="dialogVisiblesas"
      width="30%"
      center
    >
      <span v-if="thisa.users.status === '已驳回'"
        >申请讲师驳回原因：{{ thisa.users.bhyy }}</span
      >
      <span v-if="doctorData[0] && doctorData[0].status === '已驳回'"
        >申请医生驳回原因：{{ doctorData[0].cause }}</span
      >
      <span slot="footer" class="dialog-footer"> </span>
    </el-dialog>
    <!-- v-if="this.$store.state.usert.dentity != '老师'" -->
    <el-form :model="thisa" :rules="rules" ref="thisa" class="demo-ruleForm">
      <el-row :gutter="28" type="flex" align="middle">
        <el-col :span="6"><div class="grid-content purple">头像</div></el-col>
        <el-col :span="6">
          <div class="grid-content bg-purple">
            <el-row class="demo-avatar demo-basic">
              <el-col :span="12">
                <div class="demo-basic--circle">
                  <div class="block">
                    <!-- <el-avatar
                    shape="square"
                    :size="50"
                    :src="thisa.users.tx"
                  ></el-avatar> -->
                    <el-upload
                      action="https://jsonplaceholder.typicode.com/posts/"
                      class="avatar-uploader"
                      :show-file-list="false"
                      :on-change="picthandleChange"
                    >
                      <img v-if="imageUrl" :src="imageUrl" class="avatar" />
                      <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    </el-upload>
                  </div>
                </div>
              </el-col>
            </el-row>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="28" type="flex" align="middle">
        <el-col :span="6"><div class="grid-content purple">姓名</div></el-col>
        <el-col :span="10"
          ><div class="grid-content bg-purple">
            <el-form-item
              prop="users.name"
              :rules="[
                {
                  required: thisa.users.dentity === '老师',
                  message: '请输入姓名',
                  trigger: 'blur',
                },
              ]"
            >
              <el-input
                v-model="thisa.users.name"
                size="small"
                placeholder="请输入内容"
              ></el-input>
            </el-form-item></div
        ></el-col>
      </el-row>
      <el-row :gutter="28" type="flex" align="middle">
        <el-col :span="6"><div class="grid-content purple">性别</div></el-col>
        <el-col :span="10"
          ><div class="grid-content bg-purple">
            <el-form-item
              prop="users.sex"
              class="purples"
              :rules="[
                {
                  required: thisa.users.dentity === '老师',
                  message: '请输入性别',
                  trigger: 'change',
                },
              ]"
            >
              <el-radio v-model="thisa.users.sex" label="男">男</el-radio>
              <el-radio v-model="thisa.users.sex" label="女">女</el-radio>
            </el-form-item>
          </div></el-col
        >
      </el-row>

      <el-row :gutter="28" type="flex" align="middle">
        <el-col :span="6"
          ><div class="grid-content purple">身份证号码</div></el-col
        >
        <el-col :span="10"
          ><div class="grid-content bg-purple">
            <el-input
              v-model="thisa.users.sfz"
              size="small"
              placeholder="请输入内容"
            ></el-input></div
        ></el-col>
      </el-row>

      <el-row :gutter="28" type="flex" align="middle">
        <el-col :span="6"
          ><div class="grid-content purple">身份证正面</div></el-col
        >
        <el-col :span="10">
          <div class="grid-content bg-purple">
            <el-upload
              action="https://jsonplaceholder.typicode.com/posts/"
              list-type="picture-card"
              :show-file-list="false"
              :on-change="picthandleChangesfzzm"
            >
              <img v-if="sfzzmUrl" :src="sfzzmUrl" style="width: 140px" />
              <i v-else class="el-icon-plus"></i>
            </el-upload></div
        ></el-col>
      </el-row>
      <el-row :gutter="28" type="flex" align="middle">
        <el-col :span="6"
          ><div class="grid-content purple">身份证反面</div></el-col
        >
        <el-col :span="10">
          <div class="grid-content bg-purple">
            <el-upload
              action="https://jsonplaceholder.typicode.com/posts/"
              list-type="picture-card"
              :show-file-list="false"
              :on-change="picthandleChangesfzfm"
            >
              <img v-if="sfzfmUrl" :src="sfzfmUrl" style="width: 140px" />
              <i v-else class="el-icon-plus"></i>
            </el-upload></div
        ></el-col>
      </el-row>

      <el-row :gutter="28" type="flex" align="middle">
        <el-col :span="6"
          ><div class="grid-content purple">出生年月</div></el-col
        >
        <el-col :span="10">
          <div class="grid-content bg-purple">
            <el-form-item
              prop="users.datefb"
              class="purples"
              :rules="[
                {
                  required: thisa.users.dentity === '老师',
                  message: '请输入出生年月日',
                  trigger: 'blur',
                },
              ]"
            >
              <el-date-picker
                v-model="thisa.users.datefb"
                type="date"
                placeholder="选择日期"
                value-format="yyyy-MM-dd"
                size="small"
              >
              </el-date-picker>
            </el-form-item></div
        ></el-col>
      </el-row>
      <el-row
        :gutter="28"
        type="flex"
        align="middle"
        v-for="(it, ind) in thisa.users.userzc"
        :key="it.id"
      >
        <el-col :span="6"><div class="grid-content purple">职称</div></el-col
        ><el-col :span="8.5"
          ><div class="grid-content bg-purple">
            <el-form-item
              :prop="`users.userzc[${ind}].zcname`"
              :rules="[
                {
                  required: thisa.users.dentity === '老师',
                  message: '请输入职称',
                  trigger: 'blur',
                },
              ]"
            >
              <el-input
                v-model="it.zcname"
                size="small"
                placeholder="请输入内容"
              ></el-input>
            </el-form-item></div
        ></el-col>

        <i
          v-if="ind == 0"
          @click="increases()"
          class="iconfont gos-tianjia1"
        ></i>

        <i
          class="iconfont gos-lajitong"
          v-if="ind !== 0"
          @click="reductionofs(ind)"
        ></i>
      </el-row>
      <el-row :gutter="28" type="flex" align="middle">
        <el-col :span="6"
          ><div class="grid-content purple">毕业院校</div></el-col
        >
        <el-col :span="10"
          ><div class="grid-content bg-purple">
            <el-input
              v-model="thisa.users.school"
              size="small"
              placeholder="请输入内容"
            ></el-input></div
        ></el-col>
      </el-row>
      <el-row :gutter="28" type="flex" align="middle">
        <el-col :span="6"><div class="grid-content purple">学历</div></el-col>
        <el-col :span="10"
          ><div class="grid-content bg-purple">
            <el-input
              v-model="thisa.users.ebackground"
              size="small"
              placeholder="请输入内容"
            ></el-input></div
        ></el-col>
      </el-row>
      <el-row :gutter="28" type="flex" align="middle">
        <el-col :span="6"><div class="grid-content purple">专业</div></el-col>
        <el-col :span="10"
          ><div class="grid-content bg-purple">
            <el-form-item prop="users.faculty">
              <el-input
                v-model="thisa.users.faculty"
                size="small"
                placeholder="请输入内容"
              ></el-input>
            </el-form-item></div
        ></el-col>
      </el-row>
      <el-row
        :gutter="28"
        type="flex"
        align="middle"
        v-for="(item, indexs) in thisa.users.userzs"
        :key="indexs"
      >
        <el-col :span="6"
          ><div v-if="indexs === 0" class="grid-content purple">
            证书
          </div></el-col
        >
        <el-col :span="8.2"
          ><div class="grid-content bg-purple">
            <el-form-item
              :prop="`users.userzs[${indexs}].zsname`"
              :rules="[
                {
                  required: thisa.users.dentity === '老师',
                  message: '请输入证书',
                  trigger: 'blur',
                },
              ]"
            >
              <el-input
                v-model="item.zsname"
                size="small"
                placeholder="请输入内容"
              ></el-input>
            </el-form-item>
          </div>
        </el-col>
        <!-- 增加 -->

        <i
          v-if="indexs == 0"
          @click="increase()"
          class="iconfont gos-tianjia1"
        ></i>
        <!-- 删除 -->

        <i
          class="iconfont gos-lajitong"
          v-if="indexs !== 0"
          @click="reductionof(indexs)"
        >
        </i>
      </el-row>
      <el-row :gutter="28" type="flex" align="middle">
        <el-col :span="6"
          ><div class="grid-content purple">工作单位</div></el-col
        >
        <el-col :span="10"
          ><div class="grid-content bg-purple">
            <el-form-item
              prop="users.organization"
              :rules="[
                {
                  required: thisa.users.dentity === '老师',
                  message: '请输入工作单位',
                  trigger: 'blur',
                },
              ]"
            >
              <el-input
                v-model="thisa.users.organization"
                size="small"
                placeholder="请输入内容"
              ></el-input>
            </el-form-item></div
        ></el-col>
      </el-row>
      <!-- <el-row :gutter="28" type="flex" align="middle">
      <el-col :span="6"
        ><div class="grid-content purple">学院/单位</div></el-col
      >
      <el-col :span="10"
        ><div class="grid-content bg-purple">
          <el-input
            v-model="thisa.users.pfession"
            size="small"
            placeholder="请输入内容"
          ></el-input></div
      ></el-col>
    </el-row> -->
      <!-- <el-row :gutter="28" type="flex" align="middle">
        <el-col :span="6"><div class="grid-content purple">职业</div></el-col>
        <el-col :span="10"
          ><div class="grid-content bg-purple">
            <el-input
              v-model="thisa.users.career"
              size="small"
              placeholder="请输入内容"
            ></el-input></div
        ></el-col>
      </el-row> -->
      <el-row :gutter="28" type="flex" align="middle">
        <el-col :span="6"><div class="grid-content purple">邮箱</div></el-col>
        <el-col :span="10"
          ><div class="grid-content bg-purple">
            <el-input
              v-model="thisa.users.contact"
              size="small"
              placeholder="请输入内容"
            ></el-input></div
        ></el-col>
      </el-row>
      <el-row :gutter="28" type="flex" align="middle">
        <el-col :span="6"
          ><div class="grid-content purple">联系地址</div></el-col
        >
        <el-col :span="10"
          ><div class="grid-content bg-purple">
            <el-input
              v-model="thisa.users.caddress"
              size="small"
              placeholder="请输入内容"
            ></el-input></div
        ></el-col>
      </el-row>
      <el-row :gutter="28" type="flex" align="middle">
        <el-col :span="6"><div class="grid-content purple">手机号</div></el-col>
        <el-col :span="10"
          ><div class="grid-content bg-purple">
            <el-form-item prop="users.phone">
              <el-input
                :disabled="true"
                v-model="thisa.users.phone"
                size="small"
                placeholder="请输入内容"
              ></el-input>
            </el-form-item></div
        ></el-col>
      </el-row>
      <el-row :gutter="28" type="flex" align="middle">
        <el-col :span="6"
          ><div class="grid-content purple">个人简介</div></el-col
        >
        <el-col :span="10"
          ><div class="grid-content bg-purple">
            <el-form-item
              prop="users.iresume"
              :rules="[
                {
                  required: thisa.users.dentity === '老师',
                  message: '请输入学校/单位',
                  trigger: 'blur',
                },
              ]"
            >
              <el-input
                type="textarea"
                :autosize="{ minRows: 2, maxRows: 4 }"
                placeholder="请输入内容"
                v-model="thisa.users.iresume"
              >
              </el-input>
            </el-form-item></div
        ></el-col>
      </el-row>
      <div style="margin-right: 60px">
        <el-button
          type="primary"
          v-if="thisa.users.dentity === '老师'"
          class="buttons"
          @click="updusers('thisa')"
          >保存</el-button
        >
        <el-button
          type="primary"
          v-else
          class="buttons"
          @click="upduserss('thisa')"
          >保存</el-button
        >
        <el-button
          type="primary"
          :disabled="
            thisa.users.status === '已申请' || thisa.users.status === '已通过'
          "
          class="buttons"
          @click="aaaa('thisa')"
          >申请成为讲师</el-button
        >
      </div>

      <el-row :gutter="28" type="flex" align="middle">
        <el-col :span="6">
          <div class="grid-content purple">医师资格证书</div>
        </el-col>
        <el-col :span="10">
          <div class="grid-content bg-purple">
            <el-upload
              action="https://jsonplaceholder.typicode.com/posts/"
              list-type="picture-card"
              :show-file-list="false"
              :on-change="picthandleChangeyszgzs"
            >
              <img v-if="yszgzsUrl" :src="yszgzsUrl" style="width: 140px" />
              <i v-else class="el-icon-plus"></i>
            </el-upload>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="28" type="flex" align="middle">
        <el-col :span="6">
          <div class="grid-content purple">行医资格证证书</div>
        </el-col>
        <el-col :span="10">
          <div class="grid-content bg-purple">
            <el-upload
              action="https://jsonplaceholder.typicode.com/posts/"
              list-type="picture-card"
              :show-file-list="false"
              :on-change="picthandleChangexyzgzs"
            >
              <img v-if="xyzgzsUrl" :src="xyzgzsUrl" style="width: 140px" />
              <i v-else class="el-icon-plus"></i>
            </el-upload>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="28" type="flex" align="middle">
        <el-col :span="6">
          <div class="grid-content purple">职称证</div>
        </el-col>
        <el-col :span="10">
          <div class="grid-content bg-purple">
            <el-upload
              action="https://jsonplaceholder.typicode.com/posts/"
              list-type="picture-card"
              :show-file-list="false"
              :on-change="picthandleChangezcz"
            >
              <img v-if="zczUrl" :src="zczUrl" style="width: 140px" />
              <i v-else class="el-icon-plus"></i>
            </el-upload>
          </div>
        </el-col>
      </el-row>
      <div style="margin-right: 60px">
        <el-button
          type="primary"
          :disabled="!sfsys"
          class="buttons"
          @click="save"
          >保存</el-button
        >
        <el-button
          type="primary"
          :disabled="sfsys"
          class="buttons"
          @click="ApplyingDoctor"
          >申请成为医生</el-button
        >
      </div>
    </el-form>
  </div>
</template>
<script>
import {
  upduser,
  seluser,
  upduserzt,
  insdoctor,
  seldoctor,
  updoctor,
} from "../../../api/patient";
import Bus from "@/utils/bus";
export default {
  data() {
    return {
      dialogVisiblesas: false,
      Thepicture: "",
      imageUrl: "",
      sfzzm: "",
      sfzfm: "",
      yszgzs: "",
      xyzgzs: "",
      zcz: "",
      sfzzmUrl: "",
      sfzfmUrl: "",
      yszgzsUrl: "",
      xyzgzsUrl: "",
      zczUrl: "",
      sfsys: false,

      dialogVisible: false,
      thisa: {
        users: {
          dentity: [],
        },
        certificate: [],
        certif: [],
      },
      isa: 0,
      doctorData: [],

      //   circleUrl: 'https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png',
      squareUrl:
        "https://cube.elemecdn.com/9/c2/f0ee8a3c7c9638a54940382568c9dpng.png",
      sizeList: ["small"],
      rules: {
        users: {
          purples: [
            { required: true, message: "请选择性别", trigger: "change" },
          ],
          name: [{ required: true, message: "请输入姓名", trigger: "blur" }],

          faculty: [
            { required: false, message: "请输入专业", trigger: "blur" },
          ],
          organization: [
            { required: true, message: "请输入学校/单位", trigger: "blur" },
          ],
          iresume: [
            { required: true, message: "请输入个人介绍", trigger: "blur" },
          ],
        },
        // certificate: { zc: [{ required: true, message: '请输入职称', trigger: 'blur' }] }
      },
    };
  },
  created() {
    this.Toobtain();
    this.getseldoctor();
  },
  mounted() {
    Bus.$emit("activeRouter", "/");
  },
  methods: {
    //医生信息保存
    save() {
      let data = new FormData();
      data.append("phone", this.$store.state.user.phone);
      if (this.yszgzs) {
        data.append("ysnvqfile", this.yszgzs);
      }
      if (this.xyzgzs) {
        data.append("xynvqfile", this.xyzgzs);
      }
      if (this.zcz) {
        data.append("zcnvpfile", this.zcz);
      }
      data.append("id", this.doctorData[0].id);
      updoctor(data).then((res) => {
        this.$message({
          showClose: true,
          message: "保存成功",
          type: "success",
        });
      });
    },
    getseldoctor() {
      let data = new FormData();
      data.append("phone", this.$store.state.user.phone);
      data.append("rows", 1);
      data.append("page", 10);
      seldoctor(data).then((res) => {
        this.doctorData = res.records;
        if (this.doctorData.length !== 0) {
          this.yszgzsUrl = this.$store.state.https + res.records[0].ysnvq;
          this.xyzgzsUrl = this.$store.state.https + res.records[0].xynvq;
          this.zczUrl = this.$store.state.https + res.records[0].zcnvp;
          if (
            this.doctorData.length != 0 &&
            this.doctorData[0].status !== "已驳回"
          ) {
            this.sfsys = true;
          }
        }
      });
    },
    //申请成为医生
    ApplyingDoctor() {
      // console.log(this.Thepicture);
      // console.log(this.thisa.users.name);
      // console.log(this.thisa.users.sex);
      // console.log(this.thisa.users.sfz);
      // console.log(this.sfzzm);
      if (
        this.imageUrl == "" ||
        this.thisa.users.name == "" ||
        this.thisa.users.sex == "" ||
        this.thisa.users.sfz == "" ||
        this.sfzzm == "" ||
        this.sfzfm == "" ||
        this.zcname == "" ||
        this.organization == "" ||
        this.thisa.users.phone == "" ||
        this.thisa.users.iresume == ""
      ) {
        return this.$message.error("请上传完整信息后上传！");
      }
      if (this.yszgzsUrl == "") {
        return this.$message.error("请上传医师资格证");
      }
      this.callback();
      let data = new FormData();
      data.append("phone", this.$store.state.user.phone);
      if (this.yszgzs) {
        data.append("ysnvqfile", this.yszgzs);
      }
      if (this.xyzgzs) {
        data.append("xynvqfile", this.xyzgzs);
      }
      if (this.zcz) {
        data.append("zcnvpfile", this.zcz);
      }
      if (this.doctorData.length == 0) {
        insdoctor(data).then((res) => {
          this.$message({
            showClose: true,
            message: "申请成功，请耐心等待审核!",
            type: "success",
          });
        });
      } else {
        data.append("id", this.doctorData[0].id);
        data.append("status", "待审核");
        updoctor(data).then((res) => {
          this.$message({
            showClose: true,
            message: "申请成功，请耐心等待审核!",
            type: "success",
          });
        });
      }
    },
    picthandleChangezcgzs(file) {
      const isJPG =
        file.raw.type === "image/png" ||
        file.raw.type === "image/jpg" ||
        file.raw.type === "image/jpeg";
      if (!isJPG) {
        this.$message.error("上传头像图片只能是 png/jpg/jpeg 格式!");
      }
    },
    picthandleChangeyszgzs(file) {
      const isJPG =
        file.raw.type === "image/png" ||
        file.raw.type === "image/jpg" ||
        file.raw.type === "image/jpeg";
      if (!isJPG) {
        this.$message.error("上传头像图片只能是 png/jpg/jpeg 格式!");
      } else {
        this.yszgzs = file.raw;
        this.yszgzsUrl = URL.createObjectURL(file.raw);
      }
    },
    picthandleChangesfzzm(file) {
      const isJPG =
        file.raw.type === "image/png" ||
        file.raw.type === "image/jpg" ||
        file.raw.type === "image/jpeg";
      if (!isJPG) {
        this.$message.error("上传头像图片只能是 png/jpg/jpeg 格式!");
      } else {
        this.sfzzm = file.raw;
        this.sfzzmUrl = URL.createObjectURL(file.raw);
      }
    },
    picthandleChangesfzfm(file) {
      const isJPG =
        file.raw.type === "image/png" ||
        file.raw.type === "image/jpg" ||
        file.raw.type === "image/jpeg";
      if (!isJPG) {
        this.$message.error("上传头像图片只能是 png/jpg/jpeg 格式!");
      } else {
        this.sfzfm = file.raw;
        this.sfzfmUrl = URL.createObjectURL(file.raw);
      }
    },
    picthandleChangexyzgzs(file) {
      const isJPG =
        file.raw.type === "image/png" ||
        file.raw.type === "image/jpg" ||
        file.raw.type === "image/jpeg";
      if (!isJPG) {
        this.$message.error("上传头像图片只能是 png/jpg/jpeg 格式!");
      } else {
        this.xyzgzs = file.raw;
        this.xyzgzsUrl = URL.createObjectURL(file.raw);
      }
    },
    picthandleChangezcz(file) {
      const isJPG =
        file.raw.type === "image/png" ||
        file.raw.type === "image/jpg" ||
        file.raw.type === "image/jpeg";
      if (!isJPG) {
        this.$message.error("上传头像图片只能是 png/jpg/jpeg 格式!");
      } else {
        this.zcz = file.raw;
        this.zczUrl = URL.createObjectURL(file.raw);
      }
    },
    picthandleChange(file, fileList) {
      const isJPG =
        file.raw.type === "image/png" ||
        file.raw.type === "image/jpg" ||
        file.raw.type === "image/jpeg";
      const isLt2M = file.raw.size / 1024 / 1024 < 10;
      if (!isJPG) {
        this.$message.error("上传头像图片只能是 png/jpg/jpeg 格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 10MB!");
      }
      if (isJPG === true && isLt2M === true) {
        this.Thepicture = file.raw;
        this.imageUrl = URL.createObjectURL(file.raw);
        // console.log(this.Thepicture, this.imageUrl)
      }
      // else {
      // this.Thepicture = file.raw
      // this.imageUrl = URL.createObjectURL(file.raw)
      // }
      return !isJPG;
    },
    // handleAvatarSuccess (res, file) {
    //   this.Thepicture = file.raw
    //   this.imageUrl = URL.createObjectURL(file.raw)
    //   console.log(this.Thepicture, '12321')
    // },
    beforeAvatarUpload(file) {
      const isJPG =
        file.raw.type === "image/png" ||
        file.raw.type === "image/jpg" ||
        file.raw.type === "image/jpeg";
      const isLt2M = file.raw.size / 1024 / 1024 < 10;
      if (!isJPG) {
        this.$message.error("上传头像图片只能是 JPG 格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      return isJPG && isLt2M;
    },
    //   自减
    reductionof(i) {
      this.thisa.users.userzs.splice(i, 1);
    },
    // 自增
    increase() {
      this.thisa.users.userzs.push({ zsname: "" });
    },
    //   自减
    reductionofs(i) {
      this.thisa.users.userzc.splice(i, 1);
    },
    // 自增
    increases() {
      this.thisa.users.userzc.push({ zcname: "" });
    },
    //   获取
    async Toobtain() {
      var data = new FormData();
      data.append("id", this.$store.state.user.id);
      seluser(data).then((res) => {
        console.log(res);
        this.$store.commit("getUser", res);
        this.thisa.users = res;
        this.imageUrl = this.$store.state.https + this.thisa.users.tx;
        if (this.thisa.users.userzc.length === 0) {
          this.thisa.users.userzc.push({ zcname: "" });
        }
        if (this.thisa.users.userzs.length === 0) {
          this.thisa.users.userzs.push({ zcname: "" });
        }
        console.log(res.status);
        if (res.status === "已申请") {
          this.thisa.users.dentity = "老师";
        }
        if (
          this.thisa.users.datefb === "null" ||
          this.thisa.users.datefb === null
        ) {
          this.thisa.users.datefb = "";
        }
      });
    },
    aaaa(wwww) {
      if (this.thisa.users.status === "待申请") {
        this.thisa.users.dentity = "老师";
        setTimeout(() => {
          this.callback();
          this.lecturer(wwww);
        }, 1000);
      } else {
        // this.thisa.users.dentity = '老师'
        this.lecturer(wwww);
      }
    },
    // 申请成为讲师
    lecturer(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          var data = new FormData();
          data.append("id", this.thisa.users.id);
          data.append("status", "已申请");
          data.append("dentity", "注册用户");
          upduserzt(data).then((res) => {
            this.$message({
              showClose: true,
              message: res.msg,
              type: "success",
            });
            this.Toobtain();
          });
        } else {
          this.$message.error("请填写完整");
        }
      });
    },
    callback() {
      this.thisa.users.zc = [];
      this.thisa.users.zs = [];
      for (let i = 0; i < this.thisa.users.userzc.length; i++) {
        this.thisa.users.zc.push(this.thisa.users.userzc[i].zcname);
      }
      for (let s = 0; s < this.thisa.users.userzs.length; s++) {
        this.thisa.users.zs.push(this.thisa.users.userzs[s].zsname);
      }
      var data = new FormData();
      data.append("id", this.thisa.users.id);
      if (this.Thepicture !== "") {
        data.append("txpicture", this.Thepicture);
      } else {
        data.append("tx", this.thisa.users.tx);
      }
      data.append("name", this.thisa.users.name);
      data.append("sex", this.thisa.users.sex);
      data.append("sfz", this.thisa.users.sfz);
      data.append("datefb", this.thisa.users.datefb);
      data.append("school", this.thisa.users.school);
      data.append("ebackground", this.thisa.users.ebackground);
      data.append("faculty", this.thisa.users.faculty);
      data.append("iresume", this.thisa.users.iresume);
      data.append("zs", this.thisa.users.zs);
      data.append("organization", this.thisa.users.organization);
      data.append("pfession", this.thisa.users.pfession);
      data.append("career", this.thisa.users.career);
      data.append("contact", this.thisa.users.contact);
      data.append("caddress", this.thisa.users.caddress);
      data.append("phone", this.thisa.users.phone);
      data.append("zc", this.thisa.users.zc);
      upduser(data).then((res) => {
        if (res.code.code === "OK") {
          this.Thepicture = "";
          this.$store.commit("userts", res.user);
        }
        this.Toobtain();
        // this.thisa.users =
      });
    },
    //  编辑
    updusers(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.thisa.users.zc = [];
          this.thisa.users.zs = [];
          for (let i = 0; i < this.thisa.users.userzc.length; i++) {
            this.thisa.users.zc.push(this.thisa.users.userzc[i].zcname);
          }
          for (let s = 0; s < this.thisa.users.userzs.length; s++) {
            this.thisa.users.zs.push(this.thisa.users.userzs[s].zsname);
          }

          var data = new FormData();
          data.append("id", this.thisa.users.id);
          if (this.Thepicture !== "") {
            data.append("txpicture", this.Thepicture);
          } else {
            data.append("tx", this.thisa.users.tx);
          }
          data.append("name", this.thisa.users.name);
          data.append("sex", this.thisa.users.sex);
          data.append("sfz", this.thisa.users.sfz);
          data.append("datefb", this.thisa.users.datefb);
          data.append("school", this.thisa.users.school);
          data.append("ebackground", this.thisa.users.ebackground);
          data.append("faculty", this.thisa.users.faculty);
          data.append("iresume", this.thisa.users.iresume);
          data.append("zs", this.thisa.users.zs);
          data.append("organization", this.thisa.users.organization);
          data.append("pfession", this.thisa.users.pfession);
          data.append("career", this.thisa.users.career);
          data.append("contact", this.thisa.users.contact);
          data.append("caddress", this.thisa.users.caddress);
          data.append("phone", this.thisa.users.phone);
          data.append("zc", this.thisa.users.zc);
          upduser(data).then((res) => {
            console.log(res);
            if (res.code.code === "OK") {
              this.$message({
                showClose: true,
                message: res.code.msg,
                type: "success",
              });
              // this.Toobtain()
            }
            console.log(res);

            // this.thisa.users =
            this.Thepicture = "";
            this.$store.commit("userts", res.user);
            this.Toobtain();
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

    upduserss() {
      if (
        this.thisa.users.name !== "" &&
        this.thisa.users.name !== null &&
        this.thisa.users.sex !== "" &&
        this.thisa.users.sex !== null
      ) {
        this.thisa.users.zc = [];
        this.thisa.users.zs = [];
        for (let i = 0; i < this.thisa.users.userzc.length; i++) {
          this.thisa.users.zc.push(this.thisa.users.userzc[i].zcname);
        }
        for (let s = 0; s < this.thisa.users.userzs.length; s++) {
          this.thisa.users.zs.push(this.thisa.users.userzs[s].zsname);
        }

        var data = new FormData();
        data.append("id", this.thisa.users.id);
        if (this.Thepicture !== "") {
          data.append("txpicture", this.Thepicture);
        } else {
          data.append("tx", this.thisa.users.tx);
        }
        data.append("name", this.thisa.users.name);
        data.append("sex", this.thisa.users.sex);
        data.append("sfz", this.thisa.users.sfz);
        data.append("datefb", this.thisa.users.datefb);
        data.append("school", this.thisa.users.school);
        data.append("ebackground", this.thisa.users.ebackground);
        data.append("faculty", this.thisa.users.faculty);
        data.append("iresume", this.thisa.users.iresume);
        data.append("zs", this.thisa.users.zs);
        data.append("organization", this.thisa.users.organization);
        data.append("pfession", this.thisa.users.pfession);
        data.append("career", this.thisa.users.career);
        data.append("contact", this.thisa.users.contact);
        data.append("caddress", this.thisa.users.caddress);
        data.append("phone", this.thisa.users.phone);
        data.append("zc", this.thisa.users.zc);
        upduser(data).then((res) => {
          console.log(res);
          if (res.code.code === "OK") {
            this.$message({
              showClose: true,
              message: res.code.msg,
              type: "success",
            });
          }
          console.log(res);
          this.Thepicture = "";
          this.$store.commit("userts", res.user);
          this.Toobtain();
        });
      } else {
        this.$message({
          message: "请填写完成后进行保存",
          type: "warning",
        });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.Myinfor {
  .Thetitle {
    text-align: left;
    margin-top: 29px;
    // margin-left: 24px;
    margin-bottom: 40px;
    font-size: 16px;
    font-family: Source Han Sans CN;
    font-weight: bold;
    color: #333333;
  }
}
.el-row {
  margin-bottom: 20px;
  &:last-child {
    margin-bottom: 0;
  }
}
.el-col {
  border-radius: 4px;
}
.bg-purple-dark {
  background: #99a9bf;
}
.bg-purple {
  display: flex;
  justify-content: flex-start;
  width: 269px;
}
.purple {
  display: flex;
  justify-content: flex-end;
  height: 100%;
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #333333;
  line-height: 37px;
  //   background: #99a9bf;
}
.bg-purple-light {
  background: #e5e9f2;
}
.grid-content {
  border-radius: 4px;
}
.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}
.bg-purple {
  .el-textarea {
    .el-textarea__inner {
      width: 700px;
      background: #ffffff;
      border: 1px solid #ececec;
      border-radius: 6px;
    }
  }
}
.el-form-item {
  width: 100%;
  margin: 0px;
}
.purples {
  display: flex;
  // width: 50%;
  text-align: left;
}
.buttons {
  margin-top: 42px;
  margin-bottom: 39px;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 62px;
  height: 62px;
  background: #ffffff;
  border: 1px solid #dbdbdb;
  border-radius: 50%;
}
img {
  object-fit: contain;
}
.Myinfor_tops {
  display: flex;
  align-content: center;
  align-items: center;
  justify-content: space-between;
  .statisid {
    margin-bottom: 40px;

    height: 15px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: bold;

    line-height: 40px;
    img {
      margin-right: 10px;
      width: 25px;
      height: 27px;
    }
    span {
      cursor: pointer;
    }
  }
}

// 适配手机端
@media (max-width: 768px) {
  .Myinfor {
    .Thetitle {
      margin-top: 20px;
      margin-left: 10px;
    }
  }
  .bg-purple {
    width: 60vw;
  }
}
</style>
<style lang="scss" scoped>
.el-form-item ::v-deep .el-form-item__content .el-textarea .el-textarea__inner {
  overflow: hidden;
  resize: none !important;
}
</style>
